<template>
  <div style="padding-top: 35px">
    <p class="navadno-besedilo">
      V procesu zagotavljanja najvišje kakovosti storitev vaše podatke upravljamo z največjo skrbnostjo in
      upoštevamo najvišje standarde, ki jih določa veljavna zakonodaja.<br/>
      Več informacij o obdelavi vaših podatkov lahko najdete v dokumentu
      Informacije o obdelavi osebnih podatkov v družbi T - 2 d.o.o., ki je dostopen
      <a :href="povezava" class="primarna-barva">
        tukaj
      </a>.
    </p>
    <div class="grid-container">
      <div>
        <div class="levi-pomik-slika">
          <img src="/static/img/OsebniPodatkiSoglasja/ikona-8.png" class="velikost-slike">
        </div>
        <div>
          <div class="pomik-besedila-soglasja">
            <p>
              <b class="postavitev-naslova-soglasja">
                Pravilnost osebnih podatkov
              </b>
            </p>
            <p class="postavitev-besedila-soglasja navadno-besedilo">
              Do svojih podatkov lahko vedno dostopate preko naročniškega portala
              Moj T-2 pod zavihkom Moj T-2 ID, kjer jih po potrebi lahko tudi dopolnite
              ali spremenite. Za uspešno sodelovanje je pomembno, da imamo točne
              podatke, zato priporočamo, da nas o spremembi obvestite ali jih popravite
              v Mojem T-2.
            </p>
          </div>
        </div>
      </div>
      <div>
        <div class="levi-pomik-slika">
          <img src="/static/img/OsebniPodatkiSoglasja/ikona-7.png" class="velikost-slike">
        </div>
        <div>
          <div class="pomik-besedila-soglasja">
            <p>
              <b class="postavitev-naslova-soglasja">
                Naše zaveze
              </b>
            </p>
            <p class="postavitev-besedila-soglasja navadno-besedilo">
              • Zaščita vaših podatkov je vedno na prvem mestu
              <br/>
              • Želimo, da razumete naše aktivnosti pri zbiranju in uporabi podatkov
              <br/>
              • Nadzor nad vašimi podatki imate vi
              <br/>
              • Vaših osebnih podatkov ne bomo posredovali nepooblaščenim osebam
              <br/>
              • Prizadevamo se za varno uporabo interneta
            </p>
          </div>
        </div>
      </div>
      <div>
        <div class="levi-pomik-slika">
          <img src="/static/img/OsebniPodatkiSoglasja/ikona-6.png" class="velikost-slike">
        </div>
        <div>
          <div class="pomik-besedila-soglasja">
            <p>
              <b class="postavitev-naslova-soglasja">
                Uporaba vaših podatkov
              </b>
            </p>
            <p class="postavitev-besedila-soglasja navadno-besedilo">
              Podatke, ki nam jih posredujete ali jih zberemo ob koriščenju naših
              storitev, uporabljamo za vodenje naročniškega razmerja, podporo pri vaši
              uporabi storitev, obračune, zaračunavanje storitev in kupljenega blaga,
              zagotavljanje plačil, vzdrževanje, varovanje in zaščito delovanja storitev
              in našega omrežja, obvladovanje zlorab ter trženje. Obdelava podatkov se
              vselej izvaja pod pogojem, da zanjo obstoji ena od veljavnih pravnih podlag.
            </p>
          </div>
        </div>
      </div>
      <div>
        <div class="levi-pomik-slika">
          <img src="/static/img/OsebniPodatkiSoglasja/ikona-5.png" class="velikost-slike">
        </div>
        <div>
          <div class="pomik-besedila-soglasja">
            <p>
              <b class="postavitev-naslova-soglasja">
                Posredovanje podatkov samo, če soglašate!
              </b>
            </p>
            <p class="postavitev-besedila-soglasja navadno-besedilo">
              Če soglašate, vaše podatke uporabljamo tudi za posredovanje imeniški
              službi, prenosljivost storitev, tržne raziskave vključno z anketiranjem,
              trženjem in spremljanjem vaše zvestobe. V primeru, da ste član programa
              zvestobe T-2 Klub si želimo, da vam lahko ponudbo predstavimo brez omejitev.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {povezave} from './../../../../../assets/js/Povezave/povezave'

export default {
  name: 'OsebniPodatkiInfo',
  data () {
    return {
      povezava: ''
    }
  },
  mounted () {
    this.povezava = povezave.BASE_URL_VARNOST_OSEBNIH_PODATKOV
  }
}
</script>

<style scoped>
.pomik-besedila-soglasja {
  text-align: left;
}

.postavitev-naslova-soglasja {
  padding-left: 30px;
  font-size: 20px;
}

.levi-pomik-slika {
  float: left;
}

.grid-container {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 20px 50px;
  padding-top: 20px;
}

.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 20px 0;
  font-size: 30px;
}

.velikost-slike {
  width: 80px;
  border-radius: 10px;
}

.postavitev-besedila-soglasja {
  margin-left: 110px;
  padding-top: 20px;
}

@media only screen and (max-width: 1750px) {
  .grid-container {
    display: grid;
    grid-template-columns: auto;
    grid-gap: 20px 50px;
    padding: 10px;
  }

  .grid-container > div {
    text-align: center;
    padding: 20px 0;
    font-size: 30px;
  }
}

@media screen and (max-width: 700px) {
  .levi-pomik-slika {
    float: none;
    text-align: left;
  }

  .postavitev-besedila-soglasja {
    margin-left: 0;
  }

  .postavitev-naslova-soglasja {
    padding-left: 0;
    padding-top: 10px;
  }

  .velikost-slike {
    padding-bottom: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/OsebniPodatkiInSoglasja/OsebniPodatkiInfo.vue